import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['menu', 'toggle', 'item', 'subMenu', 'subToggle']
  static values = { open: { type: Boolean, default: false } }

  connect() {
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener('click', this.handleClickOutside)
    document.addEventListener('keydown', this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside)
    document.removeEventListener('keydown', this.handleKeydown)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.openValue = !this.openValue
  }

  openValueChanged() {
    if (this.openValue) {
      this.menuTarget.classList.add('open')
      this.toggleTarget.setAttribute('aria-expanded', 'true')
      this.menuTarget.focus()
    } else {
      this.menuTarget.classList.remove('open')
      this.toggleTarget.setAttribute('aria-expanded', 'false')
    }
  }

  markWithinSubmenu() {
    clearTimeout(this.subeMenuTimer)
    this.withinSubmenu = true
  }

  clearActiveFromItem(e) {
    clearTimeout(this.subeMenuTimer)

    this.subeMenuTimer = setTimeout(() => {
      if (this.withinSubmenu) {
        return
      }

      this.clearActive(e)
    }, 100)
  }

  markActive(event) {
    this.withinSubmenu = false
    clearTimeout(this.subeMenuTimer)

    const index = event.currentTarget.dataset.dropdownIndex
    this.subToggleTargets.forEach(subToggle =>
      subToggle.setAttribute('aria-expanded', subToggle.dataset.dropdownIndex === index)
    )
    this.subMenuTargets.forEach(subMenu =>
      subMenu.setAttribute('aria-expanded', subMenu.dataset.dropdownIndex === index)
    )
  }

  clearActive(event) {
    if (event?.target?.getAttribute('aria-expanded') === 'false') {
      return
    }

    this.withinSubmenu = false
    clearTimeout(this.subeMenuTimer)

    this.subToggleTargets.forEach(subToggle => subToggle.setAttribute('aria-expanded', 'false'))
    this.subMenuTargets.forEach(subMenu => subMenu.setAttribute('aria-expanded', 'false'))
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.openValue = false
    }
  }

  handleKeydown(event) {
    if (!this.openValue) return

    switch (event.key) {
      case 'Escape':
        event.preventDefault()
        this.openValue = false
        this.toggleTarget.focus()
        break
      case 'ArrowDown':
        event.preventDefault()
        this.focusNextItem(1)
        break
      case 'ArrowUp':
        event.preventDefault()
        this.focusNextItem(-1)
        break
      case 'Home':
        event.preventDefault()
        this.focusItem(0)
        break
      case 'End':
        event.preventDefault()
        this.focusItem(this.itemTargets.length - 1)
        break
    }
  }

  focusNextItem(direction) {
    const items = Array.from(this.itemTargets)
    const currentIndex = items.indexOf(document.activeElement)
    let nextIndex = currentIndex + direction

    if (nextIndex < 0) nextIndex = items.length - 1
    if (nextIndex >= items.length) nextIndex = 0

    this.focusItem(nextIndex)
  }

  focusItem(index) {
    const item = this.itemTargets[index]
    if (item) item.focus()
  }
}
